import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLeadpagesRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#603EFF",
		d: "M7.42344 10.862L15.6674 15.182C15.7754 15.236 15.9014 15.236 16.0094 15.182L24.2534 10.862C24.4154 10.772 24.4154 10.556 24.2534 10.466L16.0094 6.14597C15.9014 6.09197 15.7754 6.09197 15.6674 6.14597L7.42344 10.466C7.26144 10.556 7.26144 10.772 7.42344 10.862ZM5.13744 14.858L15.6674 20.366C15.7754 20.42 15.9014 20.42 16.0094 20.366L26.5394 14.858C26.7014 14.768 26.7014 14.552 26.5394 14.462L23.5154 12.878L16.0094 16.82C15.9014 16.874 15.7754 16.874 15.6674 16.82L8.16144 12.896L5.13744 14.48C4.97544 14.552 4.97544 14.768 5.13744 14.858ZM28.9514 18.692L25.6394 16.964L16.0094 22.022C15.9014 22.076 15.7754 22.076 15.6674 22.022L6.01944 16.964L2.70744 18.692C2.54544 18.782 2.54544 18.998 2.70744 19.088L15.6494 25.874C15.7574 25.928 15.8834 25.928 15.9914 25.874L28.9334 19.088C29.1134 18.998 29.1134 18.782 28.9514 18.692Z"
	})
});
export default SvgLeadpagesRegularIcon;
